import React, { FunctionComponent } from 'react'
import { CenterPanel } from 'view/routes/routesLayout'
import { UsersHeroPanel } from './UsersHeroPanel'
import { UsersGrid } from './UsersGrid'

export const UsersScreen: FunctionComponent = () => {
  return (
    <CenterPanel>
      <UsersHeroPanel />
      <UsersGrid />
    </CenterPanel>
  )
}
